module.exports = __webpack_public_path__ + "img/rotateicon.405c5b14.svg";